import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../store/actions/notificationAction';

import pickupOrderRemote from '../../api/pickupOrderRemote';

import PickupOrderContainer from '../pickupOrder/PickupOrderContainer';
import DropOffOrderContainer from '../dropOffOrder/DropOffOrderContainer';

import User, { UserRoleType } from '../../models/User';
import PickupOrder from '../../models/PickupOrder';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';

import moment, { Moment } from 'moment';
import MomentUtils from "@date-io/moment";
import { PO_SCHEMA } from '../../utils/pickupOrder';
import style from './myOrderDetailsContainer.module.css';

interface OrderProps {
  match: { isExact: boolean; params: { orderNumber: string }; path: string; url: string; };
  receiveError: Function;
  user: User;
  type: string;
};

interface OrderState {
  order: PickupOrder; 
  pickupDate: Moment;
  pickupDateErrorMsg: string;
};

class Order extends Component<OrderProps, OrderState> {

  state = {
    order: PO_SCHEMA,
    pickupDate: new MomentUtils().date(),
    pickupDateErrorMsg: ''
  }

  componentDidMount() {

    const orderNumber: string = this.props.match.params.orderNumber;

    pickupOrderRemote.getPickupOrder(orderNumber).then((resp: ApiResponse<PickupOrder>) => {

      const order: PickupOrder | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (order) {

        const pickupDateInDateFormat: Date = moment(order.pickup_date, "YYYYMMDD").toDate();
        const dateToMoment: Moment = new MomentUtils().date(pickupDateInDateFormat);

        this.setState({ order, pickupDate: dateToMoment });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  clearPickupDateErrorMsg = (): void => {
    this.setState({ pickupDateErrorMsg: '' });
  }

  render() {

    const view: JSX.Element = this.props.type === 'po' || this.props.type === 'go' ?

      <PickupOrderContainer
        pickupOrder={ this.state.order }
        showDetails={ false }
        type={ this.props.type }
        pickupDate={ this.state.pickupDate }
        clearPickupDateErrorMsg={ this.clearPickupDateErrorMsg }
        backToList={ true }
        showLine={ true }
        userRole={ UserRoleType.FORWARDER }
      />
    :
      <DropOffOrderContainer 
        dropOffOrder={ this.state.order }
        showDetails={ false }
        pickupDate={ this.state.pickupDate }
        showTruckerInfo={ true }
        backToList={ true }
        showLine={ true }
        userRole={ UserRoleType.FORWARDER }
      />
      
    return (
      <div className={ style.poWrapper } >
        { view }
      </div>
    );
  }
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
  
export default connect(null, mapDispatchToProps)(Order);